import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d6ae024"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mb-3" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "row row-banner-images mb-5" }
const _hoisted_5 = { class: "col-12" }
const _hoisted_6 = { class: "table align-middle mt-4" }
const _hoisted_7 = { class: "border-dark border-bottom pb-2" }
const _hoisted_8 = { class: "border-dark border-bottom" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-12 col-xl-6" }
const _hoisted_12 = {
  key: 0,
  class: "row"
}
const _hoisted_13 = { class: "col-12" }
const _hoisted_14 = {
  key: 1,
  class: "row"
}
const _hoisted_15 = { class: "col-12 col-xl-6 mb-3" }
const _hoisted_16 = {
  key: 2,
  class: "row row-description mb-4"
}
const _hoisted_17 = { class: "col-6" }
const _hoisted_18 = { class: "description bg-light rounded p-3" }
const _hoisted_19 = { class: "mb-4" }
const _hoisted_20 = { class: "d-flex align-items-center fs-3 mb-0" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas me-2" }, "comment", -1))
const _hoisted_22 = { class: "body" }
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "col-12 col-xl-6 mb-4" }
const _hoisted_25 = { class: "row" }
const _hoisted_26 = { class: "col-5" }
const _hoisted_27 = { class: "col-5" }
const _hoisted_28 = {
  key: 0,
  class: "col-2"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "close", -1))
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = {
  key: 3,
  class: "row"
}
const _hoisted_32 = { class: "col-12 col-xl-6 mb-4" }
const _hoisted_33 = { class: "row row-bottom" }
const _hoisted_34 = { class: "col-12 col-xl-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_title = _resolveComponent("base-title")!
  const _component_banner_library_detail_banner_item = _resolveComponent("banner-library-detail-banner-item")!
  const _component_Subtitle = _resolveComponent("Subtitle")!
  const _component_input_select = _resolveComponent("input-select")!
  const _component_ProductFilterPicker = _resolveComponent("ProductFilterPicker")!
  const _component_I18nPageLinkPicker = _resolveComponent("I18nPageLinkPicker")!
  const _component_MultilingualSwitcher = _resolveComponent("MultilingualSwitcher")!
  const _component_i18n_input_text_editor = _resolveComponent("i18n-input-text-editor")!
  const _component_input_date = _resolveComponent("input-date")!
  const _component_input_number = _resolveComponent("input-number")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_GenericFormWrapper = _resolveComponent("GenericFormWrapper")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", _hoisted_1, [
      _createVNode(_component_base_title, {
        title: _ctx.title ?? _ctx.$t('banner'),
        mode: _ctx.mode,
        "back-route": _ctx.returnRouteObject,
        "help-text": _ctx.helpText,
        "is-library": _ctx.isLibrary,
        mb: 3
      }, null, 8, ["title", "mode", "back-route", "help-text", "is-library"])
    ]),
    _createVNode(_component_GenericFormWrapper, {
      submitData: _ctx.submitData,
      pageUI: _ctx.pageUI,
      buttonClass: "btn-sm"
    }, {
      content: _withCtx(({errors}) => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("section", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("table", _hoisted_6, [
                  _createElementVNode("thead", _hoisted_7, [
                    _createElementVNode("tr", _hoisted_8, [
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('banner')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('format')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('language')), 1)
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableLanguages(), (language) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: language }, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['SIZE_1_1', 'SIZE_1_2'], (bannerSize) => {
                          return _createElementVNode("tr", { key: bannerSize }, [
                            _createElementVNode("td", null, [
                              _createVNode(_component_banner_library_detail_banner_item, {
                                "banner-image": _ctx.findBannerImage(language, bannerSize),
                                "language-code": language,
                                "content-size-code": bannerSize,
                                onBannerImageUploaded: _ctx.addBannerImage,
                                onBannerImageDeleted: () => _ctx.deleteBannerImage(language, bannerSize)
                              }, null, 8, ["banner-image", "language-code", "content-size-code", "onBannerImageUploaded", "onBannerImageDeleted"])
                            ]),
                            _createElementVNode("td", {
                              innerHTML: _ctx.contentSizeCodeToHumanReadable(bannerSize)
                            }, null, 8, _hoisted_9),
                            _createElementVNode("td", null, _toDisplayString(language?.toUpperCase() ?? _ctx.$t('cms.languageIndependent')), 1)
                          ])
                        }), 64))
                      ], 64))
                    }), 128))
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_Subtitle, {
                  title: _ctx.$t('link'),
                  subtitle: _ctx.$t('cms.link.description')
                }, null, 8, ["title", "subtitle"]),
                _createVNode(_component_input_select, {
                  modelValue: _ctx.currentBannerLinkType,
                  "onUpdate:modelValue": [
                    _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentBannerLinkType) = $event)),
                    _ctx.onFormDataChanged
                  ],
                  name: _ctx.$t('linkType'),
                  label: _ctx.$t('linkType'),
                  selectText: _ctx.$t('selectText'),
                  options: _ctx.bannerLinkTypeOptions,
                  errors: errors,
                  class: "mb-3"
                }, null, 8, ["modelValue", "name", "label", "selectText", "options", "errors", "onUpdate:modelValue"])
              ])
            ]),
            (_ctx.currentBannerLinkType === _ctx.bannerLinkTypeEnum.PRODUCT_FILTER)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_ProductFilterPicker, {
                      payload: _ctx.productFilterPickerPayload,
                      "product-filter": _ctx.productFilter,
                      errors: errors,
                      onPayloadChanged: _ctx.onProductFilterPickerChanged,
                      onProductFilterChanged: _ctx.onProductFilterChanged
                    }, null, 8, ["payload", "product-filter", "errors", "onPayloadChanged", "onProductFilterChanged"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.currentBannerLinkType === _ctx.bannerLinkTypeEnum.LINK)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_I18nPageLinkPicker, {
                      payload: _ctx.pageLinkPayload,
                      "enable-no-link": false,
                      errors: errors,
                      onChanged: _ctx.onPageLinkPickerChanged,
                      onExceptions: _ctx.setExceptions
                    }, null, 8, ["payload", "errors", "onChanged", "onExceptions"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.isLibrary)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("section", _hoisted_18, [
                      _createElementVNode("header", _hoisted_19, [
                        _createElementVNode("h2", _hoisted_20, [
                          _hoisted_21,
                          _createTextVNode(_toDisplayString(_ctx.$t('remark')), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_22, [
                        _createVNode(_component_MultilingualSwitcher, {
                          errors: errors,
                          "active-language": _ctx.activeLanguage,
                          onUpdateActiveLanguage: _cache[1] || (_cache[1] = (newValue) => _ctx.activeLanguage = newValue)
                        }, null, 8, ["errors", "active-language"]),
                        _createVNode(_component_i18n_input_text_editor, {
                          data: _ctx.contentBlock.description,
                          mode: "bare",
                          height: 150,
                          id: "remark",
                          name: _ctx.$t('remark'),
                          placeholder: _ctx.$t('placeholderBannerRemark'),
                          errors: errors,
                          "active-language": _ctx.activeLanguage,
                          "onUpdate:modelValue": _ctx.onFormDataChanged
                        }, null, 8, ["data", "name", "placeholder", "errors", "active-language", "onUpdate:modelValue"])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createVNode(_component_Subtitle, {
                  title: _ctx.$t('period'),
                  subtitle: _ctx.$t('cms.period.description')
                }, null, 8, ["title", "subtitle"]),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _createVNode(_component_input_date, {
                      label: _ctx.$t('begin'),
                      placeholder: "DD-MM-JJJJ",
                      name: "begin",
                      modelValue: _ctx.contentBlock.begin_date,
                      "onUpdate:modelValue": [
                        _cache[2] || (_cache[2] = ($event: any) => ((_ctx.contentBlock.begin_date) = $event)),
                        _ctx.onFormDataChanged
                      ],
                      rules: "req_if_end:@begin,@end",
                      class: "mb-n1 me-3",
                      errors: errors
                    }, null, 8, ["label", "modelValue", "errors", "onUpdate:modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createVNode(_component_input_date, {
                      label: _ctx.$t('end'),
                      placeholder: "DD-MM-JJJJ",
                      name: "end",
                      modelValue: _ctx.contentBlock.end_date,
                      "onUpdate:modelValue": [
                        _cache[3] || (_cache[3] = ($event: any) => ((_ctx.contentBlock.end_date) = $event)),
                        _ctx.onFormDataChanged
                      ],
                      rules: "req_if_begin:@begin,@end|comes_after:@begin,@end",
                      class: "mb-n1 me-3",
                      errors: errors
                    }, null, 8, ["label", "modelValue", "errors", "onUpdate:modelValue"])
                  ]),
                  (_ctx.contentBlock.begin_date || _ctx.contentBlock.end_date)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                        _createElementVNode("button", {
                          onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.clearBannerPeriod()), ["prevent"])),
                          class: "btn btn-icon btn-sm"
                        }, _hoisted_30)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            (_ctx.mode !== _ctx.PageDetailModeEnum.NEW)
              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    _createVNode(_component_Subtitle, {
                      title: _ctx.$t('cms.order'),
                      subtitle: _ctx.$t('cms.order.description')
                    }, null, 8, ["title", "subtitle"]),
                    _createVNode(_component_input_number, {
                      label: _ctx.$t('sortWeight'),
                      placeholder: "sortWeight",
                      name: "sortWeight",
                      modelValue: _ctx.contentBlock.sort_weight,
                      "onUpdate:modelValue": [
                        _cache[5] || (_cache[5] = ($event: any) => ((_ctx.contentBlock.sort_weight) = $event)),
                        _ctx.onFormDataChanged
                      ],
                      errors: errors
                    }, null, 8, ["label", "modelValue", "errors", "onUpdate:modelValue"])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("section", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _createVNode(_component_Subtitle, {
                  title: _ctx.$t('cms.visibility'),
                  subtitle: _ctx.$t('cms.visibility.description')
                }, null, 8, ["title", "subtitle"]),
                _createElementVNode("div", null, [
                  _createVNode(_component_input_select, {
                    name: "cbStatus",
                    selectText: _ctx.$t('selectText'),
                    modelValue: _ctx.contentBlock.status_code,
                    "onUpdate:modelValue": [
                      _cache[6] || (_cache[6] = ($event: any) => ((_ctx.contentBlock.status_code) = $event)),
                      _ctx.onFormDataChanged
                    ],
                    options: _ctx.statusOptions,
                    errors: errors
                  }, null, 8, ["selectText", "modelValue", "options", "errors", "onUpdate:modelValue"])
                ])
              ])
            ])
          ])
        ])
      ]),
      buttons: _withCtx(() => [
        _createVNode(_component_router_link, {
          class: "ms-3 btn btn-outline-primary btn-sm",
          to: _ctx.returnRouteObject
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('cancel')), 1)
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _: 1
    }, 8, ["submitData", "pageUI"])
  ], 64))
}